import React from "react";
import PropTypes from "prop-types";
//Material imports
import { ThemeProvider, makeStyles } from "@material-ui/core/styles";
//Limitless imports
import { useResources } from "@limitless/common/hooks";
import { createTheme } from "@limitless/customer/theme/Theme";
import { useCustomerMessageContext } from "@limitless/customer/hooks";
import ExpertDialogue from "@limitless/customer/components/dialogues/expert-dialogue/ExpertDialogue";
import { useMobileDetectionContext } from "hooks/mobile-detection/MobileDetectionContext";
import { useReachOutContext } from "hooks/reach-out/ReachOutContext";
import Fab from "../fab/Fab";

const useStyles = makeStyles({
    reachOutContainer: {
        position: "fixed",
        width: 420,
        "&:hover": {
            cursor: "pointer"
        },
        flex: 1,
        display: "flex",
        marginLeft: "auto",
        flexDirection: "row",
        justifyContent: "flex-end",
        marginRight: 16,
        maxWidth: "calc(100vw - 48px)"
    },
    dialogueContainerOverrides: {
        maxWidth: "unset"
    }
});

const ReachOutExperience = ({ onFABClick }) => {
    const { isMobileDevice, getCustomOffsetStyles } = useMobileDetectionContext();
    const {
        resources: { theme }
    } = useResources();
    const { message } = useCustomerMessageContext();
    const {
        reachOutMessage: { reachOutDialogue },
        handleReachOutClick,
        handleCloseReachOut
    } = useReachOutContext();
    const [unReadMessage, setUnReadMessage] = React.useState(false);
    const classes = useStyles();
    const offsetStyles = React.useMemo(() => getCustomOffsetStyles(55, isMobileDevice ? -10 : null), []);

    if (!reachOutDialogue) {
        return null;
    }

    const handleFABClick = () => {
        handleReachOutClick(onFABClick);
    };

    const handleClose = () => {
        handleCloseReachOut();
        if (message.messageId) {
            setUnReadMessage(true);
        }
    };

    if (!message.expertAuthors) {
        message.expertAuthors = {};
    }

    return (
        <ThemeProvider theme={createTheme(theme)}>
            <div className="llm-anchor">
                <div className="llm-shadow">
                    <div className={classes.reachOutContainer} onClick={handleFABClick} style={offsetStyles}>
                        <ExpertDialogue
                            shouldAnimate
                            message={message}
                            dialogue={reachOutDialogue}
                            dialogueContainerOverrides={classes.dialogueContainerOverrides}
                        />
                    </div>
                </div>
                <Fab isLLMVisible isMobileDevice={false} onClick={handleClose} unReadMessage={unReadMessage} />
            </div>
        </ThemeProvider>
    );
};

export default ReachOutExperience;

ReachOutExperience.propTypes = {
    onFABClick: PropTypes.func.isRequired
};
